export default "__VITE_ASSET__DRLeagxr__"